<template>
  <div id="app">
    <div class="home">
      <!-- <firstPageNav v-if="showNav && !newsPage"></firstPageNav> -->
      <TopNav v-if="!newsPage" @messageSent="toggleTheme" />

      <div v-if="ShowText" class="three">
        <h1>{{ text }}</h1>
      </div>
    </div>
    <div v-if="loading" class="ShowAllLoadingIf">
      <div>
        <svg
          id="noConnection"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 315 245"
        >
          <defs>
            <linearGradient
              id="a"
              x1="-138.48"
              y1="486.02"
              x2="-137.54"
              y2="486.02"
              gradientTransform="matrix(96, 0, 0, -5.19, 13416, 2735.93)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stop-color="#FFFFFF" stop-opacity="0" />
              <stop offset="1" stop-color="#FFFFFF" />
            </linearGradient>
          </defs>

          <title>noConnection</title>

          <g class="star" data-animator-group="true" data-animator-type="2">
            <path
              class="b"
              d="M278.54,23a1.46,1.46,0,1,1,2.92,0v3a1.46,1.46,0,0,1-2.92,0ZM272,33.46a1.46,1.46,0,1,1,0-2.92h3a1.46,1.46,0,0,1,0,2.92ZM281.46,40a1.46,1.46,0,0,1-2.92,0V37a1.46,1.46,0,1,1,2.92,0ZM288,30.54a1.46,1.46,0,0,1,0,2.92h-3a1.46,1.46,0,1,1,0-2.92Z"
              fill="white"
            />
          </g>

          <path
            class="c circlesBottom"
            d="M273.49,180.75a1.46,1.46,0,1,1,2.89-.42,8,8,0,1,1-9-6.78,1.47,1.47,0,0,1,.42,2.9,5.07,5.07,0,1,0,5.7,4.3Z"
            fill="white"
          />

          <path
            class="c"
            d="M158.49,27.75a1.46,1.46,0,1,1,2.89-.42,8,8,0,1,1-9-6.78,1.47,1.47,0,0,1,.42,2.9,5.07,5.07,0,1,0,5.7,4.3Z"
            fill="white"
          />

          <path
            class="d circlesTop"
            d="M301,109c2.42-.77,6.14-3.77,7-7,.78,2.86,4.05,6.23,7,6.49-3.32,1.19-6.5,4.73-7,7.51-.34-2.83-4.73-6.59-7-7"
            fill="white"
          />

          <path
            class="d circlesBottom"
            d="M13,166.5a6,6,0,0,0,3.5-3.5,4.77,4.77,0,0,0,3.5,3.24A5.88,5.88,0,0,0,16.5,170c-.17-1.42-2.37-3.29-3.5-3.5"
            fill="white"
          />

          <path
            class="c circlesBottom"
            d="M6,99a3,3,0,1,1-3-3,3,3,0,0,1,3,3"
            fill="white"
          />

          <path
            class="c circlesBottom"
            d="M65.54,3A1.54,1.54,0,1,0,64,4.54,1.54,1.54,0,0,0,65.54,3Zm2.92,0A4.46,4.46,0,1,1,64-1.46,4.46,4.46,0,0,1,68.46,3Z"
            fill="white"
          />

          <path
            class="c circlesTop"
            d="M47.37,198.1a2.54,2.54,0,1,0-1.47,3.27A2.53,2.53,0,0,0,47.37,198.1Zm-7.47,2.84a5.46,5.46,0,1,1,7,3.16A5.44,5.44,0,0,1,39.9,200.94Z"
            fill="white"
          />

          <g class="cloud">
            <path
              class="c"
              d="M232.5,119.58a28.69,28.69,0,0,1-28.68,28.69,29.13,29.13,0,0,1-5.1-.46h-85.4a18.25,18.25,0,0,1-2.43-.16,28.69,28.69,0,0,1-9.71-55.58,27.78,27.78,0,0,1,34.45-21.85A41.77,41.77,0,0,1,208.7,90.65a31.14,31.14,0,0,1,23.8,28.93Z"
              fill="white"
            />

            <path
              class="f"
              d="M216.13,99.33a23.48,23.48,0,0,0-10-4.08L204.2,95l-.21-1.9a36.77,36.77,0,0,0-65.51-18.42L137.39,76l-1.68-.56A22.75,22.75,0,0,0,105.9,94.25l-.2,1.6-1.54.48a23.69,23.69,0,0,0,6.91,46.32,20,20,0,0,0,2.25.16h85.86a24.44,24.44,0,0,0,4.64.46,23.69,23.69,0,0,0,12.44-43.85l1.32-2.13Z"
              fill="white"
            />

            <polygon
              class="e lightning"
              points="142 165.7 156.59 165.7 148.95 190.09 183 155.6 162.5 155.6 164.28 148 151.34 148 142 165.7"
              fill="white"
            />
          </g>
        </svg>

        <div class="rain">
          <div class="drop slow"></div>
          <div class="drop fast"></div>
          <div class="drop"></div>
          <div class="drop faster"></div>
        </div>
        <div class="shadow"></div>
        <div class="ShowToUser">اینترنت قطع شد</div>
      </div>

      <!--      <div class="dotted-loader"></div>-->
    </div>
    <SplashScreen />
    <!-- <router-view></router-view> -->
    <router-view v-slot="{ Component }">
      <template v-if="keepAlive">
        <keep-alive :include="['HomeUser', 'CategoryPage']">
          <component :is="Component" />
        </keep-alive>
      </template>
      <component :is="Component" v-else />
    </router-view>
    <!-- <router-view v-else /> -->
    <MenuBar v-if="ShowText1 && showMenuBar" />
    <FooterUser v-if="ShowText1" />

    <LoginUser v-if="$store.state.login_modal" />
    <div v-if="ShowModel" class="updateAlert" @click="modalCloseHandler">
      <div class="alertContainer" @click.stop>
        <div class="iconWrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="updateIcon"
          >
            <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"></path>
            <polyline points="7 11 12 16 17 11"></polyline>
            <line x1="12" y1="4" x2="12" y2="16"></line>
          </svg>
        </div>
        <div class="containerTitle">بروزرسانی</div>
        <div class="containerDesc">
          برای تجربه بهتر و استفاده از قابلیت‌های جدید، لطفاً اپلیکیشن را به
          آخرین نسخه بروزرسانی کنید.
        </div>
        <div class="containerOptions">
          <div class="optionThumb mainThumb" @click.stop="UpdateProgram">
            بروزرسانی
          </div>
          <div class="optionThumb" @click.stop="modalCloseHandler">بعدا</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuBar from "@/views/menuBar";
import TopNav from "@/components/TopNav/TopNav.vue";
import FooterUser from "@/views/FooterUser";
import LoginUser from "@/views/LoginUser";
import axios from "axios";
import SplashScreen from "@/views/splashScreen";
import store from "@/store";
import MobileDetect from "mobile-detect";
import { App } from "@capacitor/app";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import initPushNotifications from "./push-notifications";
// import firstPageNav from "./components/TopNav/firstPageNav.vue";
import { StatusBar, Style } from "@capacitor/status-bar";

export default {
  components: {
    MenuBar,
    TopNav,
    // firstPageNav,
    FooterUser,
    LoginUser,
    SplashScreen,
  },
  data() {
    return {
      theme: "light",
      FalseWeather: false,
      cssLoaded: false,
      ShowText1: true,
      text: "",
      ShowText: false,
      weather: {},
      loading: false,
      checkInterval: null,
      sessionPrev: "",
      backClickCount: 0,
      ShowModel: false,
      keepAlive: false,
    };
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(newPath) {
        this.updateTextAndCss(newPath);
        this.checkInternetConnection();
        this.sessionPrev = sessionStorage.getItem("prevPage");
      },
    },
  },
  created() {
    this.check_login();
    this.customer_setting();
    this.checkInterval = setInterval(this.checkInternetConnection, 100);
    this.loadTheme();
    this.sessionPrev = sessionStorage.getItem("prevPage");
    StatusBar.setOverlaysWebView({ overlay: false });
    StatusBar.setBackgroundColor({ color: "#000" });
    StatusBar.setStyle({ style: Style.Dark });

    this.$router.afterEach((to, from) => {
      const catToDet = from.name == "CategoryPage" && to.name == "DetailsPost";
      const detToCat = from.name == "DetailsPost" && to.name == "CategoryPage";
      const toHome = to.name == "HomeUser";

      this.keepAlive = catToDet || detToCat || toHome;
    });
  },
  beforeUnmount() {
    clearInterval(this.checkInterval);
  },
  computed: {
    newsPage() {
      const currentPath = this.$route.path;
      return (
        currentPath === "/news" ||
        currentPath === "/news-details" ||
        currentPath.startsWith("/builder-create-post")
      );
    },
    showMenuBar() {
      return (
        this.$route.path != "/complaint-tracking" &&
        this.$route.path != "/complaint" &&
        this.$route.path != "/property-evaluator" &&
        this.$route.path != "/property-evaluator/result" &&
        this.$route.path != "/commission-calculator" &&
        !this.$route.path.startsWith("/builder-details")
      );
    },
  },
  mounted() {
    //const fireData = "12345678";
    //this.$store.commit("setFire", fireData);
    this.checkUpdateVersionHandler();
    initPushNotifications(this.$store);
    this.detectDevice();
    App.addListener("backButton", ({ canGoBack }) => {
      var route_name = this.$route.path;
      var route_name2 = this.$route.fullPath;
      if (route_name === "/" || route_name == "/home") {
        if (this.backClickCount == 1) {
          App.exitApp();
        } else {
          this._spring();
          return true;
        }
      }
      if (route_name2 == "/submit-house?step=4") {
        this.$router.replace("/");
        return;
      }
      if (canGoBack) {
        window.history.back();
      }
    });
    this.fetchWeather();
    this.refreshInformations();
  },
  methods: {
    modalCloseHandler() {
      this.ShowModel = false;
    },
    UpdateProgram() {
      if (this.$store.state.c_set && this.$store.state.c_set.app_link) {
        window.location.href = this.$store.state.c_set.app_link;
      }
    },
    async checkUpdateVersionHandler() {
      const info = await App.getInfo();
      this.helperGet("setting").then((res) => {
        const settings = res.data.data;
        if (settings.version != info.version) {
          this.ShowModel = true;
        }
      });
    },
    refreshInformations() {
      const hasToken = localStorage.getItem("_token");
      if (!hasToken) return;
      const isRefresh = sessionStorage.getItem("updated");
      if (!isRefresh) {
        this.helperPost("current-user-info").then((r) => {
          if (r.data.result == "1") {
            this.$store.commit("setAuth", r.data);
            this.$store.dispatch("checkAuth");
          }
        });
        if (this.$store.state.auth.role == "branch_admin") {
          this.get_branch_info();
        }
        sessionStorage.setItem("updated", "Done");
      }
    },
    async get_branch_info() {
      var branch_infos = null;
      await this.helperGet("branch-infos").then((res) => {
        if (res.data.result == "1") {
          branch_infos = res.data.data;
        }
      });
      localStorage.setItem("branchinof", JSON.stringify(branch_infos));
    },
    detectDevice() {
      const md = new MobileDetect(window.navigator.userAgent);
      this.userAgent = window.navigator.userAgent;

      if (md.mobile()) {
        this.deviceType = "Mobile";
      } else if (md.tablet()) {
        this.deviceType = "Tablet";
      } else {
        this.deviceType = "Desktop";
      }
      this.$store.commit("setDevice", this.deviceType);
    },
    _spring() {
      this.backClickCount = 1;
      toast.warning("برای خروج دوباره دکمه بازگشت را بزنید");
    },
    check_login() {
      this.$store.dispatch("checkToken");
      this.checktoken();
    },

    checktoken() {
      this.helperPost("check-token").then((res) => {
        if (res.data.result == 1) {
          this.$store.dispatch("checkAuth");
        } else {
          localStorage.removeItem("auth");
          localStorage.removeItem("_token");
        }
      });
      // .catch(error => console.log(error))
    },

    customer_setting() {
      this.helperGet("setting").then((res) => {
        this.$store.commit("optionSet", res.data.data);

        console.log("cset", this.$store.state.c_set);
        console.log("cset", res.data.data);
      });
    },

    toggleTheme() {
      this.theme = this.theme === "light" ? "dark" : "light";
      this.$nextTick(() => {
        localStorage.setItem("theme", this.theme);
        this.applyTheme();
      });
    },

    loadTheme() {
      const savedTheme = localStorage.getItem("theme");
      console.log(savedTheme);
      if (savedTheme) {
        this.theme = savedTheme;
        this.$nextTick(() => {
          this.applyTheme();
        });
      } else {
        this.theme = "light";
        this.$nextTick(() => {
          this.applyTheme();
        });
      }
    },

    applyTheme() {
      if (this.theme === "dark") {
        document.body.classList.add("dark");
        document.documentElement.classList.add("dark");
        document.body.style.backgroundColor = "#101A23";
        this.$store.commit("setTheme", "dark");
      } else {
        document.body.classList.remove("dark");
        document.documentElement.classList.remove("dark");
        document.body.style.backgroundColor = "#fff";
        this.$store.commit("setTheme", "light");
      }
    },

    checkInternetConnection() {
      if (navigator.onLine) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    },

    updateTextAndCss(newPath) {
      document.body.style = "overflow: auto;";
      console.log("newPath", newPath);

      if (
        !newPath.startsWith("/category") &&
        !newPath.startsWith("/map-house") &&
        !newPath.startsWith("/details")
      ) {
        localStorage.removeItem("post_fillter");
        store.dispatch("checkPostFillter");
      }

      document.body.style.overflow = "auto";

      if (
        newPath === "/" ||
        newPath === "/chat" ||
        newPath === "/home/" ||
        newPath === "/home" ||
        newPath === "/contact-us" ||
        newPath === "/about-us" ||
        newPath === "/news" ||
        newPath === "/news-details" ||
        newPath === "/category" ||
        newPath === "/commission-calculator" ||
        newPath === "/property-evaluator" ||
        newPath == "/property-evaluator/result" ||
        newPath === "/complaint" ||
        newPath === "/complaint-tracking" ||
        newPath === "/payment-list" ||
        newPath.startsWith("/builder-create-post") ||
        newPath.startsWith("/builder-post-details") ||
        newPath.startsWith("/details")
      ) {
        this.ShowText = false;
      } else {
        this.ShowText = true;
      }

      if (
        newPath === "/chat" ||
        newPath.startsWith("/builder-create-post") ||
        newPath.startsWith("/details")
      ) {
        this.ShowText1 = false;
      } else {
        this.ShowText1 = true;
      }

      switch (newPath) {
        case "/wallet":
          this.text = "کیف پول";
          break;
        case "/amlak-list":
          this.text = "املاک";
          break;
        case "/profile":
          this.text = "پروفایل";
          break;
        case "/user-profile":
          this.text = "پروفایل";
          break;
        case "/my-profile-builder":
          this.text = "پروفایل";
          break;
        case "/myads":
          this.text = "فایل من";
          break;
        case "/top-users":
          this.text = "امتیاز برتر";
          break;
        case "/profile-personal":
        case "/profile-superior":
        case "/profile-builder":
        case "/profile-amlak":
          this.text = "پروفایل";
          break;
        case "/bookmark":
          this.text = "ذخیره";
          break;
        case "/map-house":
          this.text = "جستجو در نقشه";
          break;
        case "/amlak-region":
          this.text = "مشاوران املاک";
          break;
        case "/map-amlak":
          this.text = "جستجوی املاک";
          break;
        case "/users-list": {
          const role = this.$route.query.role;
          if (role === "builder") {
            this.text = "سازندگان معتبر";
          } else if (role === "consultant") {
            this.text = "برترین مشاوران";
          } else {
            this.text = "معتبرترین ها ";
          }
          break;
        }
        default:
      }
    },

    async fetchWeather() {
      const url =
        "https://api.open-meteo.com/v1/forecast?latitude=36.5667&longitude=52.3667&current_weather=true";

      try {
        const response = await axios.get(url);
        this.weather = response.data;
        console.log(this.weather); // بررسی داده‌های دریافتی
      } catch (error) {
        console.error("Error fetching weather data:", error);
      }
    },
    getWeatherDescription(code) {
      const descriptions = {
        0: "آسمان صاف",
        1: "آسمان کمی ابری",
        2: "آسمان ابری",
        3: "بارش باران",
        4: "برف",
        5: "مه",
      };
      return descriptions[code] || "وضعیت نامشخص";
    },
    getTimeOfDay(time) {
      const hour = new Date(time).getHours(); // استخراج ساعت از زمان
      if (hour >= 5 && hour < 12) {
        return "صبح"; // 5 صبح تا 12 ظهر
      } else if (hour >= 12 && hour < 17) {
        return "ظهر"; // 12 ظهر تا 5 بعد از ظهر
      } else if (hour >= 17 && hour < 21) {
        return "غروب"; // 5 بعد از ظهر تا 9 شب
      } else {
        return "شب"; // 9 شب تا 5 صبح
      }
    },
    getWeatherIcon(code) {
      switch (code) {
        case 0:
          return "Sun1"; // آسمان صاف
        case 1:
          return "CloudSunny"; // آسمان کمی ابری
        case 2:
          return "CloudDrizzle"; // آسمان ابری
        case 3:
          return "CloudDrizzle"; // بارش باران
        case 4:
          return "CloudDrizzle"; // برف
        case 5:
          return "CloudDrizzle"; // مه
        default:
          return "Sun"; // وضعیت نامشخص
      }
    },
  },
};
</script>

<style lang="scss">
@import url("./App.css");
@import url("./assets/styles/home.scss");

.ps {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
  margin-top: 0 !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.updateAlert {
  position: fixed;
  inset: 0;
  z-index: 9999999999;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(1px);
  animation: fadeIn 0.3s ease;

  .alertContainer {
    text-align: center;
    position: absolute;
    inset-inline: 24px;
    bottom: 24px;
    margin-inline: auto;
    width: calc(100% - 48px);
    max-width: 392px;
    padding: 32px 28px;
    background: #fff;
    color: #000;
    direction: rtl;
    border-radius: 24px;
    box-shadow: 0 2px 6px 3px rgba(0, 0, 0, 0.15);
    transform: translateY(20px);
    opacity: 0;
    animation: slideUp 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;

    .containerTitle {
      font-weight: 700;
      font-size: 1.25rem;
      margin-bottom: 8px;
    }

    .containerDesc {
      font-size: 0.875rem;
      line-height: 1.5;
      color: #545454;
      margin-bottom: 24px;
    }

    .containerOptions {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 18px;

      .optionThumb {
        width: 100%;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.9rem;
        font-weight: 700;
        border: 1px solid #e2e8f0;
        border-radius: 16px;

        &.mainThumb {
          background: #0096c7;
          color: #fff;
          border-color: #0096c7;
        }
      }
    }
  }
}

.iconWrapper {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #1fb0de, #007aa3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  box-shadow: 0 8px 24px rgba(0, 150, 199, 0.3),
    inset 0 2px 4px rgba(255, 255, 255, 0.3);
  margin-bottom: 16px;
  margin-inline: auto;
}

.updateIcon {
  width: 36px;
  height: 36px;
  color: white;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

.dark {
  .updateAlert {
    .alertContainer {
      background: #101a23;
      color: #fff;
      box-shadow: 0 2px 6px 3px rgba(255, 255, 255, 0.15);

      .containerDesc {
        color: #aeaeae;
      }
    }
  }
}
</style>
